import {
  type PermissionRouteGuardData,
  PermissionRouteGuard,
} from '@exam-management/permission-route-guard';
import { APP_PERMISSIONS } from '@exam-management/permissions';
import {
  QBankStructureDetailHeader,
  QBankStructureHeaderModalActionProvider,
  QBankStructureValidationErrorsAlert,
} from '@exam-management/qbank-structure-detail';
import { useParams } from '@exam-management/router';
import { Flex } from '@shared/components';
import { Outlet } from 'react-router-dom';

export default function QBankStructureLayout() {
  const { structureId } = useParams('/qbank-structures/:structureId');

  const defaultRoutes: PermissionRouteGuardData[] = [
    {
      path: '/qbank-structures/:structureId/dashboard',
      requiredPermission: [APP_PERMISSIONS.QBANK.DASHBOARD.VIEW],
      params: {
        structureId,
      },
    },
    {
      path: '/qbank-structures/:structureId/structure',
      requiredPermission: [APP_PERMISSIONS.QBANK.STRUCTURE.VIEW],
      params: {
        structureId,
      },
    },
    {
      path: '/qbank-structures/:structureId/qcontents',
      requiredPermission: [APP_PERMISSIONS.QBANK.QUESTION.VIEW],
      params: {
        structureId,
      },
    },
    {
      path: '/qbank-structures/:structureId/los',
      requiredPermission: [APP_PERMISSIONS.QBANK.LOS.VIEW],
      params: {
        structureId,
      },
    },
    {
      path: '/qbank-structures/:structureId/setting',
      requiredPermission: [APP_PERMISSIONS.QBANK.SETTING.VIEW],
      params: {
        structureId,
      },
    },
    {
      path: '/qbank-structures/:structureId/activity-log',
      requiredPermission: [APP_PERMISSIONS.QBANK.AUDIT_LOG.VIEW],
      params: {
        structureId,
      },
    },
  ];

  return (
    <PermissionRouteGuard routes={defaultRoutes}>
      <QBankStructureHeaderModalActionProvider>
        <Flex
          sx={{ flexDirection: 'column', width: '100%', bgcolor: 'grey.50', minHeight: '100dvh' }}
        >
          <QBankStructureDetailHeader />
          <QBankStructureValidationErrorsAlert />
          <Outlet />
        </Flex>
      </QBankStructureHeaderModalActionProvider>
    </PermissionRouteGuard>
  );
}
